import React from 'react';
import './App.css'
import LayoutSection from './layout/LayoutSection.tsx';


function App() {
  return (
    <>
      <LayoutSection />
    </>
  );
}

export default App;
